import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import axios from "axios";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Alert, Form, Input, Modal, Switch } from "antd";
import { axiosErrorHandler, showSuccessNotification } from "../../../../swzutils";
import ConsignmentPhotoList, {} from "./ConsignmentPhotoList";
import ConsignmentImageKind from "../../enums/ConsignmentImageKind";
const ConsignmentSendPODModal = (props) => {
    const formRef = React.useRef(null);
    const [stateLoading, setStateLoading] = React.useState(false);
    const [stateSelectedPhotoIds, setStateSelectedPhotoIds] = React.useState([]);
    const [stateErrorMessage, setStateErrorMessage] = React.useState(null);
    const onFormFinish = (formValues) => {
        emailPOD(formValues.emails);
    };
    const emailPOD = (emailCsv) => {
        setStateLoading(true);
        const emailAddresses = emailCsv.split(",");
        axios.post(`/admin/v1/consignments/${props.consignmentId}/documents/send-proof-of-delivery`, {
            emails: emailAddresses,
            photoIds: stateSelectedPhotoIds
        }).then(( /*response*/) => {
            showSuccessNotification(`${emailAddresses.length} email(s) sent`);
            setStateErrorMessage(null);
            props.onComplete();
        }).catch(error => {
            axiosErrorHandler(error, errorMessage => {
                setStateErrorMessage(errorMessage);
            });
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const onTogglePhotoSelection = (checked, photo) => {
        setStateSelectedPhotoIds((prev) => {
            if (checked) {
                return [...prev, photo.id];
            }
            return prev.filter(it => photo.id !== it);
        });
    };
    return (_jsxs(Modal, { title: "Email Proof of Delivery", open: props.open, okText: "Send", onOk: () => formRef.current?.submit(), onCancel: () => props.onCancel(), confirmLoading: stateLoading, children: [_jsx(Form, { ref: formRef, layout: "vertical", onFinish: onFormFinish, children: _jsx(Form.Item, { label: "Emails (separate multiple email addresses with a comma)", name: "emails", initialValue: props.emailCsv, rules: [{
                            required: true,
                            message: 'Please enter an email address',
                        }], children: _jsx(Input, { type: "email", multiple: true }) }) }), _jsx("p", { children: "Select any photos you would like to attach" }), _jsx(ConsignmentPhotoList, { consignmentId: props.consignmentId, filterKind: [ConsignmentImageKind.COMPLETION_PHOTO, ConsignmentImageKind.OTHER_PHOTO], renderActions: (item) => [
                    _jsx(Switch, { onChange: (checked) => onTogglePhotoSelection(checked, item), checkedChildren: _jsx(CheckOutlined, {}), unCheckedChildren: _jsx(CloseOutlined, {}) })
                ] }), stateErrorMessage &&
                _jsx(Alert, { type: "error", title: stateErrorMessage, banner: true })] }));
};
export default ConsignmentSendPODModal;
